<template>
  <div class="section">
    <div class="container">
      <Permissions>
        <div class="">
          <div class="">
            <p class="title">
              {{ $t("surveyCreatorTool") }}
            </p>
            <SurveyCreatorQuestions :survey="survey" @change="checkValidity" />
            <SurveyCreatorOptions :survey="survey" />
          </div>
          <b-field grouped class="pb-4 ml-4">
            <b-button type="is-success" :disabled="isDisabled" @click="saveSurvey">
              {{ $t("saveSurvey") }}
            </b-button>
          </b-field>
        </div>
      </Permissions>
    </div>
  </div>
</template>

<script>
import Permissions from "@/components/Permissions.vue";
import { functions, db } from "@/firebase";
import SurveyCreatorQuestions from "@/components/survey/SurveyCreatorQuestions";
import SurveyCreatorOptions from "@/components/survey/SurveyCreatorOptions";

export default {
  name: "SurveyCreator",
  components: {
    Permissions,
    SurveyCreatorQuestions,
    SurveyCreatorOptions,
  },
  data() {
    return {
      survey: null,
      running: false,
      isDisabled: false,
    };
  },
  watch: {
    survey() {
      if (this.survey != null) {
        this.$store.commit("LOAD_SURVEY_DATA", this.survey);
      }
    },
  },
  created() {
    this.$store.commit("FLUSH_SURVEY_DATA");
  },
  methods: {
    async saveSurvey() {
      this.isDisabled = true;
      this.isLoading = true;
      try {
        this.$store.state.survey.uid = this.$store.getters.getCurrentUser.uid;
        this.$store.state.survey.organizationId = this.$route.params.organizationId;
        console.log(this.$store.state.survey.organizationId);
        let surveyInfo = await functions.httpsCallable("CreateSurvey")({
          survey: this.$store.state.survey,
          surveyId: this.$route.params.surveyId,
        });
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("surveySaved"),
        });
        this.isLoading = false;
        this.isDisabled = false;
        if (!this.$route.params.surveyId) {
          this.$router.push({ path: `/polling/create/${surveyInfo.data}` });
        }
      } catch (error) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$t(error),
        });
      }
    },
    checkValidity() {
      this.isDisabled = false;
      let survey = this.$store.state.survey;
      if (survey.title == "") {
        this.isDisabled = true;
        return;
      }
      for (let question of survey.questions) {
        if (question.question == "") {
          this.isDisabled = true;
          return;
        }
        if (question.options.length < 2) {
          this.isDisabled = true;
          return;
        }
        let filledOptions = 0;
        for (let option of question.options) {
          if (option.text != "") {
            filledOptions += 1;
          }
        }
        if (filledOptions < 2) {
          this.isDisabled = true;
          return;
        }
      }
    },
  },
  firestore() {
    return {
      survey: db.collection("surveys").doc(this.$route.params.surveyId),
    };
  },
};
</script>

<style></style>
